/* src/app/pages/home/home.page.scss */
:host {
  background: linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), url("./media/home-bg-mobile.webp");
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}
@media (min-width: 768px) {
  :host {
    background-image: linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), url("./media/home-bg.webp");
  }
}
.lang-icon {
  height: 25px;
  width: 25px;
  border: 2px solid white;
  border-radius: 50%;
  margin-right: 2.8rem;
}
.logo-row {
  width: 100%;
}
.brand-logo {
  margin: 14% 0 10%;
  height: 11vh;
  min-height: 92px;
  max-height: 150px;
  width: 100%;
}
ion-content {
  position: relative;
  --overflow: auto;
}
.wrapper {
  height: 100%;
  padding-inline: 20px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  margin: 32px auto;
}
@media (max-width: 390px) {
  .wrapper {
    padding-top: 0;
  }
}
@media (min-width: 991px) {
  .wrapper {
    width: 640px;
    height: 100%;
  }
}
.wrapper .card {
  width: 100%;
  max-width: 500px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 32px 16px;
}
.wrapper .title-block {
  width: 100%;
}
.wrapper .title {
  width: 100%;
  text-align: center;
  margin-bottom: 12px;
  font-size: 50px;
  line-height: 120%;
  letter-spacing: 0%;
  text-align: center;
  text-transform: uppercase;
  color: var(--color-white);
}
@media (min-width: 991px) {
  .wrapper .title {
    padding-top: 0px;
    margin-bottom: 25px;
  }
}
.wrapper .border-line {
  width: 100%;
  height: 0px;
  border-bottom: 1px solid #69a669;
  opacity: 0.2;
  margin-bottom: 20px;
}
.wrapper .button {
  width: 100%;
}
.wrapper .button .order_method {
  opacity: 0.6;
  cursor: pointer;
  width: 100%;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
}
.wrapper .button .order_method.active {
  opacity: 1;
}
.wrapper .button .order_method .method_icon {
  margin-right: 10px;
  height: 44px;
  width: 44px;
}
.wrapper .button .order_method .text_block {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  margin-right: 10px;
}
.wrapper .button .order_method .text_block .title {
  font-size: 18px;
  line-height: 20.7px;
  text-align: left;
  color: var(--ion-color-primary);
  margin-bottom: 6px;
}
.wrapper .button .order_method .text_block .subtitle {
  font-size: 14px;
  line-height: 17.22px;
  text-align: left;
  color: var(--black-title);
}
.wrapper .button .order_method .method_select {
  height: 32px;
  width: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #e20026;
}
@media (min-width: 991px) {
  .wrapper .button {
    width: 80%;
    padding: 0;
  }
  .wrapper .button ion-button {
    width: 100%;
    height: 58px;
  }
}
.wrapper ion-button .button-inner {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.wrapper ion-button .button-inner .left-block {
  display: flex;
  align-items: center;
}
.wrapper ion-button .button-inner .left-block .burger {
  height: 30px;
  width: 37px;
}
.wrapper ion-button .button-inner .left-block .button-text {
  font-size: 16px;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  color: var(--color-white);
  letter-spacing: -0.5px;
}
.wrapper ion-button .button-inner .arrow-right {
  width: 20px;
  height: 20px;
}
.wrapper .payment-method {
  width: 100%;
  text-align: center;
  margin-bottom: 12px;
}
.wrapper .payment-method ion-icon {
  height: 15px;
  width: 100%;
  margin: 0 auto;
}
.payment-method-desktop {
  display: none;
}
@media (min-width: 991px) {
  .payment-method-desktop {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 35px 23px 35px;
    background-color: #83c1b1;
    margin-bottom: 80px;
  }
}
.payment-method-desktop p {
  margin: 0;
  font-size: 18px;
  line-height: 27px;
  letter-spacing: 0.01em;
  text-align: center;
  margin-bottom: 18px;
}
.payment-method-desktop ion-img {
  height: 40px;
  width: 100%;
}
.info {
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0px;
  text-align: center;
  vertical-align: middle;
  text-transform: capitalize;
  color: var(--color-white);
  margin-bottom: 44px;
}
.table {
  font-size: 40px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  text-transform: uppercase;
  color: var(--color-white);
  margin-bottom: 14px;
}
.footer-block {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding-bottom: 20px;
  width: 85px;
  flex-wrap: wrap;
  gap: 5px;
}
.footer-block ion-img {
  flex-basis: 33px;
  width: 33px;
  height: 33px;
  border-radius: 50%;
  position: relative;
  z-index: 1;
  border: 2px solid transparent;
}
.footer-block ion-img.selected {
  border: 2px solid white;
}
.header {
  --background: var(--ion-background-color);
  background: var(--ion-background-color);
  padding: var(--ion-padding, 16px);
}
.header ion-grid,
.header ion-row,
.header ion-col {
  padding: 0;
  margin: 0;
}
.header .header-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 15px;
}
.header .header-right {
  display: flex;
  align-items: flex-start;
  justify-content: end;
}
.header .header-center {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
.header .back-btn,
.header .lang-btn {
  background: transparent;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
}
.header .back-btn img,
.header .lang-btn img {
  width: 22px;
  height: 22px;
}
.header .back-btn img.flag,
.header .lang-btn img.flag {
  border: 1px solid #fff;
}
.header .header-logo {
  height: 24px;
  display: block;
}
.header .flag {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  object-fit: cover;
}
.header .address {
  font-size: 10px;
  text-align: start;
  font-weight: 400;
  margin: 0;
  display: flex;
  max-width: 180px;
  margin-right: 15px;
  color: #fff;
}
.header.transparent {
  --background: transparent;
  background: transparent;
}
.home-hint {
  background: #23262C;
  border: 1px solid #484848;
  border-radius: 9px;
  font-size: 13px;
  line-height: 17px;
}
ion-footer {
  justify-items: center;
}
.version {
  position: absolute;
  bottom: 4px;
  right: 4px;
}
/*# sourceMappingURL=home.page.css.map */
